//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "AgrMonitoringWeather",
  data() {
    return {
      deviceTypeId: "",
      btnActive: 1,
      timeVal: "",
      real: {},
      fengXiang: "",
      realAll_Temp: {
        //空气温度
        flat: false,
        vert: false,
      },
      realAll_Humidity: {
        //空气湿度
        flat: false,
        vert: false,
      },
      realAll_WindSpeed: {
        //风速
        flat: false,
        vert: false,
      },
      realAll_Light: {
        //光照强度
        flat: false,
        vert: false,
      },
      realAll_Ph: {
        //大气压力
        flat: false,
        vert: false,
      },
      realData: {
        deviceCode: "-",
        deviceName: "-",
      },
      edition: "",
      responseTime: "",
      envV4Temperature: "",
      envV4Humidity: "",
      envV4WindDirection: "",
      envV4WindSpeed: "",
      envV4Pressure: "",
      envV4Light: "",
    };
  },
  mounted() {
    this.getRealWeatherDateAll();
  },
  created() {
    this.getRealWeatherDate();
  },
  methods: {
    // 气象实时数据
    getRealWeatherDate() {
      let farmAllData = JSON.parse(sessionStorage.getItem("farmAllData"));
      this.edition = farmAllData.edition;
      this.realData = {
        deviceCode: farmAllData.deviceCode,
        deviceName: farmAllData.deviceName,
      };
      let obj = { sensorNum: this.realData.deviceCode };
      if (this.edition != 4) {
        this.$http.agrModel.getWeather(obj).then((res) => {
          if (res.status === "1") {
            if (res.data) {
              this.real = res.data;
              if (res.data.windDirection && res.data.windDirection != null) {
                if (res.data.windDirection == "W") {
                  this.fengXiang = "西";
                } else if (res.data.windDirection == "N") {
                  this.fengXiang = "北";
                } else if (res.data.windDirection == "E") {
                  this.fengXiang = "东";
                } else if (res.data.windDirection == "ES") {
                  this.fengXiang = "东南";
                } else if (res.data.windDirection == "WS") {
                  this.fengXiang = "西南";
                } else if (res.data.windDirection == "WN") {
                  this.fengXiang = "西北";
                } else if (res.data.windDirection == "S") {
                  this.fengXiang = "南";
                } else if (res.data.windDirection == "EN") {
                  this.fengXiang = "东北";
                }
              }
            }
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      } else {
        this.$http.nqMonitor
          .monitorGroupV4({ imei: this.realData.deviceCode })
          .then((res) => {
            if (res.status == 1) {
              this.responseTime = res.data.result[0].sendTime;
              if (res.data.result && res.data.result.length > 0) {
                let envV4DataList = res.data.result;
                var that = this;
                envV4DataList.forEach((val) => {
                  // A0空气温度
                  if (val.sensorType && val.sensorType == "A0") {
                    that.envV4Temperature = val.sensorData;
                  }
                  // A1空气湿度
                  if (val.sensorType && val.sensorType == "A1") {
                    that.envV4Humidity = val.sensorData;
                  }
                  // A5大气压力
                  if (val.sensorType && val.sensorType == "A5") {
                    that.envV4Pressure = val.sensorData;
                  }
                  // A3风速
                  if (val.sensorType && val.sensorType == "A3") {
                    that.envV4WindSpeed = val.sensorData;
                  }
                  // A4风向
                  if (val.sensorType && val.sensorType == "A4") {
                    if (val.sensorData && val.sensorData != null) {
                      if (val.sensorData == "W") {
                        that.envV4WindDirection = "西";
                      } else if (val.sensorData == "N") {
                        that.envV4WindDirection = "北";
                      } else if (val.sensorData == "E") {
                        that.envV4WindDirection = "东";
                      } else if (val.sensorData == "ES") {
                        that.envV4WindDirection = "东南";
                      } else if (val.sensorData == "WS") {
                        that.envV4WindDirection = "西南";
                      } else if (val.sensorData == "WN") {
                        that.envV4WindDirection = "西北";
                      } else if (val.sensorData == "S") {
                        that.envV4WindDirection = "南";
                      } else if (val.sensorData == "EN") {
                        that.envV4WindDirection = "东北";
                      }
                    }
                  }
                  // A2光照强度
                  if (val.sensorType && val.sensorType == "A2") {
                    that.envV4Light = val.sensorData;
                  }
                });
                this.deviceStatus = "设备正常";
              } else {
                this.envV4Temperature = "";
                this.envV4Humidity = "";
                this.envV4WindDirection = "";
                this.envV4WindSpeed = "";
                this.envV4Pressure = "";
                this.envV4Light = "";
                this.deviceStatus = null;
              }
            } else {
              this.deviceStatus = null;
            }
          });
      }
    },
    // 土壤历史数据
    getRealWeatherDateAll(data) {
      let time = "";
      let timeArr = [];
      let obj = {};
      let currentDay = false;
      if (this.btnActive === 1) {
        time = "w";
        obj = {
          sensorNum: this.realData.deviceCode, //传感器号
          type: time, //类型；w 最近七天；m 最近30天
        };
      } else if (this.btnActive === 2) {
        time = "m";
        obj = {
          sensorNum: this.realData.deviceCode, //传感器号
          type: time, //类型；w 最近七天；m 最近30天
        };
      } else {
        timeArr = data;
        if (this.timeVal && this.timeVal[0] != "" && this.timeVal[1] != "") {
          if (this.timeVal[0] == this.timeVal[1]) {
            currentDay = true;
          }
        }
        obj = {
          sensorNum: this.realData.deviceCode, //传感器号
          startTime: timeArr[0],
          endTime: timeArr[1],
        }; //类型；w 最近七天；m 最近30天
      }
      if (this.edition != 4) {
        this.$http.agrModel.getWeatherAll(obj).then((res) => {
          // console.log(res);
          if (res.status === "1") {
            if (res.data.length > 0) {
              this.realAll_Temp.flat = [];
              this.realAll_Humidity.flat = [];
              this.realAll_WindSpeed.flat = [];
              this.realAll_Light.flat = [];
              this.realAll_Ph.flat = [];
              this.realAll_Temp.vert = [];
              this.realAll_Humidity.vert = [];
              this.realAll_WindSpeed.vert = [];
              this.realAll_Light.vert = [];
              this.realAll_Ph.vert = [];

              res.data.forEach((item, index) => {
                this.realAll_Temp.flat.push(item.sendTime.slice(0, 10));
                this.realAll_Humidity.flat.push(item.sendTime.slice(0, 10));
                this.realAll_WindSpeed.flat.push(item.sendTime.slice(0, 10));
                this.realAll_Light.flat.push(item.sendTime.slice(0, 10));
                this.realAll_Ph.flat.push(item.sendTime.slice(0, 10));
                this.realAll_Temp.vert.push(item.temperature);
                this.realAll_Humidity.vert.push(item.humidity);
                this.realAll_WindSpeed.vert.push(item.windSpeed);
                this.realAll_Light.vert.push(item.light);
                this.realAll_Ph.vert.push(item.windDirection);
              });

              this.getEchartData1();
              this.getEchartData2();
              this.getEchartData3();
              this.getEchartData4();
              this.getEchartData5();
            } else {
              this.realAll_Temp.flat = [];
              this.realAll_Humidity.flat = [];
              this.realAll_WindSpeed.flat = [];
              this.realAll_Light.flat = [];
              this.realAll_Ph.flat = [];
              this.realAll_Temp.vert = [];
              this.realAll_Humidity.vert = [];
              this.realAll_WindSpeed.vert = [];
              this.realAll_Light.vert = [];
              this.realAll_Ph.vert = [];
            }
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      } else {
        this.$http.nqMonitor.monitorHisGroupV4(obj).then((res) => {
          console.log(res);
          if (res.data.code == 1) {
            let echartsDatas = res.data.result;
            if (echartsDatas.length > 0) {
              var that = this;
              echartsDatas.forEach((item) => {
                if (item.sensorType && item.sensorType == "A0") {
                  let soilSaltMapList = item.list;
                  if (soilSaltMapList.length > 0) {
                    that.realAll_Temp.flat = [];
                    that.realAll_Temp.vert = [];
                    soilSaltMapList.forEach((its) => {
                      that.realAll_Temp.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Temp.vert.push(its.sensorData);
                      } else {
                        that.realAll_Temp.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "A1") {
                  let soilConductivityDataMapList = item.list;
                  if (soilConductivityDataMapList.length > 0) {
                    that.realAll_Humidity.flat = [];
                    that.realAll_Humidity.vert = [];
                    soilConductivityDataMapList.forEach((its) => {
                      that.realAll_Humidity.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Humidity.vert.push(its.sensorData);
                      } else {
                        that.realAll_Humidity.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "A3") {
                  let soilSaltMapList = item.list;
                  if (soilSaltMapList.length > 0) {
                    that.realAll_WindSpeed.flat = [];
                    that.realAll_WindSpeed.vert = [];
                    soilSaltMapList.forEach((its) => {
                      that.realAll_WindSpeed.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_WindSpeed.vert.push(its.sensorData);
                      } else {
                        that.realAll_WindSpeed.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "A2") {
                  let soilConductivityDataMapList = item.list;
                  if (soilConductivityDataMapList.length > 0) {
                    that.realAll_Light.flat = [];
                    that.realAll_Light.vert = [];
                    soilConductivityDataMapList.forEach((its) => {
                      that.realAll_Light.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Light.vert.push(its.sensorData);
                      } else {
                        that.realAll_Light.vert.push(its.avgVal);
                      }
                    });
                  }
                }
              });
            } else {
              this.realAll_Temp.flat = [];
              this.realAll_Temp.vert = [];
              this.realAll_Humidity.flat = [];
              this.realAll_Humidity.vert = [];
              this.realAll_Light.flat = [];
              this.realAll_Light.vert = [];
              this.realAll_WindSpeed.flat = [];
              this.realAll_WindSpeed.vert = [];
            }
            this.getEchartData1();
            this.getEchartData2();
            this.getEchartData3();
            this.getEchartData4();
            this.getEchartData5();
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      }
    },
    // getEchartData函数都为 图表
    getEchartData1() {
      this.$nextTick(() => {
        const chart1 = document.getElementById("chart1");
        var _that = this;
        if (chart1) {
          const myChart = this.$echarts.init(chart1);
          const option = {
            tooltip: {
              trigger: "axis",

              formatter: (params) => {
                let template = "";
                params.forEach((item, index) => {
                  if (index == 0) {
                    template = item.axisValue + "<br>";
                  }
                  if (item.seriesType === "line") {
                    item.value += "";
                  }
                  template =
                    template +
                    item.marker +
                    "空气温度（℃）" +
                    " : " +
                    item.value +
                    "<br>";
                });
                return template;
              },
            },

            grid: {
              left: "3%",
              right: "6%",
              bottom: "14%",
              top: "6%",
              containLabel: true,
            },

            xAxis: {
              type: "category",
              boundaryGap: false,
              data: _that.realAll_Temp.flat,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "line",
                stack: "Total",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#cff7f9",
                    lineStyle: {
                      color: "#3FE1E7",
                    },
                  },
                },
                data: _that.realAll_Temp.vert,
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        this.$on("hook:destroyed", () => {
          window.removeEventListener("resize", function () {
            myChart.resize();
          });
        });
      });
    },
    getEchartData2() {
      this.$nextTick(() => {
        const chart2 = document.getElementById("chart2");
        if (chart2) {
          const myChart = this.$echarts.init(chart2);
          const option = {
            tooltip: {
              trigger: "axis",
              formatter: (params) => {
                let template = "";
                params.forEach((item, index) => {
                  if (index == 0) {
                    template = item.axisValue + "<br>";
                  }
                  if (item.seriesType === "line") {
                    item.value += "";
                  }
                  template =
                    template +
                    item.marker +
                    "空气湿度（%RH）" +
                    " : " +
                    item.value +
                    "<br>";
                });
                return template;
              },
            },

            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            grid: {
              left: "3%",
              right: "6%",
              bottom: "14%",
              top: "6%",
              containLabel: true,
            },

            xAxis: {
              type: "category",
              boundaryGap: false,
              data: this.realAll_Humidity.flat,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "line",
                stack: "Total",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#cff7f9",
                    lineStyle: {
                      color: "#3FE1E7",
                    },
                  },
                },
                data: this.realAll_Humidity.vert,
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        this.$on("hook:destroyed", () => {
          window.removeEventListener("resize", function () {
            myChart.resize();
          });
        });
      });
    },
    getEchartData3() {
      this.$nextTick(() => {
        const chart3 = document.getElementById("chart3");
        if (chart3) {
          const myChart = this.$echarts.init(chart3);
          const option = {
            tooltip: {
              trigger: "axis",
              formatter: (params) => {
                let template = "";
                params.forEach((item, index) => {
                  if (index == 0) {
                    template = item.axisValue + "<br>";
                  }
                  if (item.seriesType === "line") {
                    item.value += "";
                  }
                  template =
                    template +
                    item.marker +
                    "风速（km/h）" +
                    " : " +
                    item.value +
                    "<br>";
                });
                return template;
              },
            },

            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            grid: {
              left: "3%",
              right: "6%",
              bottom: "14%",
              top: "6%",
              containLabel: true,
            },

            xAxis: {
              type: "category",
              boundaryGap: false,
              data: this.realAll_WindSpeed.flat,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "line",
                stack: "Total",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#cff7f9",
                    lineStyle: {
                      color: "#3FE1E7",
                    },
                  },
                },
                data: this.realAll_WindSpeed.vert,
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        this.$on("hook:destroyed", () => {
          window.removeEventListener("resize", function () {
            myChart.resize();
          });
        });
      });
    },
    getEchartData4() {
      this.$nextTick(() => {
        const chart4 = document.getElementById("chart4");
        if (chart4) {
          const myChart = this.$echarts.init(chart4);
          const option = {
            tooltip: {
              trigger: "axis",
              formatter: (params) => {
                let template = "";
                params.forEach((item, index) => {
                  if (index == 0) {
                    template = item.axisValue + "<br>";
                  }
                  if (item.seriesType === "line") {
                    item.value += "";
                  }
                  template =
                    template +
                    item.marker +
                    "光照强度（lux）" +
                    " : " +
                    item.value +
                    "<br>";
                });
                return template;
              },
            },

            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            grid: {
              left: "3%",
              right: "6%",
              bottom: "14%",
              top: "6%",
              containLabel: true,
            },

            xAxis: {
              type: "category",
              boundaryGap: false,
              data: this.realAll_Light.flat,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "line",
                stack: "Total",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#cff7f9",
                    lineStyle: {
                      color: "#3FE1E7",
                    },
                  },
                },
                data: this.realAll_Light.vert,
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        this.$on("hook:destroyed", () => {
          window.removeEventListener("resize", function () {
            myChart.resize();
          });
        });
      });
    },
    getEchartData5() {
      this.$nextTick(() => {
        const chart5 = document.getElementById("chart5");
        if (chart5) {
          const myChart = this.$echarts.init(chart5);
          const option = {
            tooltip: {
              trigger: "axis",
              formatter: (params) => {
                let template = "";
                params.forEach((item, index) => {
                  if (index == 0) {
                    template = item.axisValue + "<br>";
                  }
                  if (item.seriesType === "line") {
                    item.value += "";
                  }
                  template =
                    template +
                    item.marker +
                    "大气压力（kpa）" +
                    " : " +
                    item.value +
                    "<br>";
                });
                return template;
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            grid: {
              left: "3%",
              right: "6%",
              bottom: "14%",
              top: "6%",
              containLabel: true,
            },

            xAxis: {
              type: "category",
              boundaryGap: false,
              data: this.realAll_Ph.flat,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "line",
                stack: "Total",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#cff7f9",
                    lineStyle: {
                      color: "#3FE1E7",
                    },
                  },
                },
                data: this.realAll_Ph.vert,
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        this.$on("hook:destroyed", () => {
          window.removeEventListener("resize", function () {
            myChart.resize();
          });
        });
      });
    },
    timeClick(num) {
      this.timeVal = "";

      this.btnActive = num;
      if (num === 1) {
        this.getRealWeatherDateAll("w");
      } else if (num === 2) {
        this.getRealWeatherDateAll("m");
      }
    },
    dateChange(val) {
      if (val && val[0]) {
        this.btnActive = 3;
      }
      this.getRealWeatherDateAll(val);
    },
  },
  components: {},
};
